import Component from '@glimmer/component'
import { t } from 'ember-intl'
import { LinkTo } from '@ember/routing'
import { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'

interface Signature {
  Element: HTMLUListElement
  Args: {
    aboutUrl: string
    privacyUrl: string
  }
}

export class FooterNav extends Component<Signature> {
  @service session!: SessionService

  get showCCPALinks() {
    return this.session.currentSchool.countryCode === 'US'
  }

  <template>
    <ul class="flex flex-wrap justify-center" ...attributes>
      <li class="px-2">
        <LinkTo data-test-home-link class="hover:text-dusty-black-100 text-white" @route="subscription-type.home">
          {{t "components.footerMain.textLinks.home"}}
        </LinkTo>
      </li>
      <li class="px-2">
        <a
          href={{@aboutUrl}}
          class="hover:text-dusty-black-100 text-white"
          data-test-about-link
          target="_blank"
          rel="noopener noreferrer"
        >
          {{t "components.footerMain.textLinks.about"}}
        </a>
      </li>
      <li class="px-2">
        <LinkTo
          @route="subscription-type.contact-us.index"
          class="hover:text-dusty-black-100 text-white"
          data-test-contact-link
        >
          {{t "components.footerMain.textLinks.contactUs"}}
        </LinkTo>
      </li>
      <li class="px-2">
        <a
          href={{@privacyUrl}}
          class="hover:text-dusty-black-100 text-white"
          data-test-privacy-link
          target="_blank"
          rel="noopener noreferrer"
        >
          {{t "components.footerMain.textLinks.privacyPolicy"}}
        </a>
      </li>
      <li class="px-2">
        <a
          href="https://www.3plearning.com/noticeforschools/"
          class="hover:text-dusty-black-100 text-white"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{t "components.footerMain.textLinks.noticeForSchools"}}
        </a>
      </li>

      {{#if this.showCCPALinks}}
        <li class="w-full px-2">
          <a
            class="hover:text-dusty-black-100 text-white"
            href="https://readingeggs.com/ccpa?locale=us"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{t "components.footerMain.textLinks.ccpa"}}
          </a>
        </li>
      {{/if}}
    </ul>
  </template>
}

export default FooterNav
